import { useMemo } from 'react';

import { useNewUserAccessRights } from '@app/hooks';

export const useLegalEntitiesPageHeader = () => {
  const {
    userAccessRights: { LegalEntities },
  } = useNewUserAccessRights();

  const hasUserRightForModuleView = useMemo(
    () => LegalEntities?.IsOn,
    [LegalEntities]
  );

  return {
    hasUserRightForModuleView,
  };
};
